import { Action, Reducer } from 'redux';
import { DONE_STATISTICS_LOADING, DONE_STATISTICS_LOADED, PURCHASE_ORDERS_STATISTICS_LOADING, PURCHASE_ORDERS_STATISTICS_LOADED, VEHICLES_GARAGES_STATISTICS_LOADING, VEHICLES_GARAGES_STATISTICS_LOADED } from "./SummaryReport.action";
import { initialState } from './SummaryReport.state';

export const SummaryReportReducer: Reducer<any, Action> = (state = initialState, action: any) => {
    let newState = state;
    switch (action.type) {
        case DONE_STATISTICS_LOADING:
            newState = { ...newState, loading: true };
            break;

        case DONE_STATISTICS_LOADED:
            newState = { ...newState, loading: false, doneStatisctics: action.payload };
            break;

        case PURCHASE_ORDERS_STATISTICS_LOADING:
            newState = { ...newState, loading: true };
            break;

        case PURCHASE_ORDERS_STATISTICS_LOADED:
            newState = { ...newState, loading: false, purchaseOrdersStatistics: action.payload };
            break;

        case VEHICLES_GARAGES_STATISTICS_LOADING:
            newState = { ...newState, loading: true };
            break;

        case VEHICLES_GARAGES_STATISTICS_LOADED:
            newState = { ...newState, loading: false, vehiclesGaragesStatistics: action.payload };
            break;
    }
    return newState;
};
